import moment from "moment";
import { useCallback, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  ListGroup,
  Row,
  Spinner,
} from "react-bootstrap";
import { BsClockHistory, BsPencilSquare } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import activityPageSlice from "./store/slice";
import styles from "./activityPage.module.scss";

const ActivityPage = () => {
  const dispatch = useDispatch();

  const data = useSelector((state) => state.activityPage.data);
  const meta = useSelector((state) => state.activityPage.meta);
  const isLoading = useSelector((state) => state.activityPage.isLoading);

  const request = useCallback(
    (page: number = 1) => dispatch(activityPageSlice.actions.request(page)),
    [dispatch]
  );

  const reset = useCallback(
    () => dispatch(activityPageSlice.actions.reset()),
    [dispatch]
  );

  useEffect(() => {
    request(1);

    return () => {
      reset();
    };
  }, [request, reset]);

  return (
    <Container fluid>
      <Row>
        <Col />
        <Col lg={6}>
          <Card className={styles.card}>
            <Card.Body>
              <Card.Title>
                <BsClockHistory /> Activity
              </Card.Title>

              <hr />

              <ListGroup variant="flush">
                {!!(isLoading && data.length === 0) && (
                  <Spinner
                    className={`text-primary ${styles.spinner}`}
                    animation="border"
                  />
                )}
                {!!(!isLoading && data.length === 0) && <span>No data</span>}
                {data.map((activity, index) => (
                  <ListGroup.Item key={index} className={styles.item}>
                    <span className="text-success">
                      <BsPencilSquare />
                    </span>
                    <span className={`${styles.date} text-muted`}>
                      {moment(activity.created_at).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}
                    </span>
                    <span>{activity.description}</span>
                  </ListGroup.Item>
                ))}
              </ListGroup>

              {meta && (
                <div className={styles.loadMore}>
                  {meta.current_page < meta.last_page ? (
                    <Button onClick={() => request(meta.current_page + 1)}>
                      Load more
                      {isLoading && (
                        <Spinner
                          size="sm"
                          animation="border"
                          className={styles.loadMoreSpinner}
                        />
                      )}
                    </Button>
                  ) : data.length > 20 ? (
                    <span className="text-muted">Nothing more to show.</span>
                  ) : null}
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col />
      </Row>
    </Container>
  );
};

export default ActivityPage;
